export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_TERRA-80X80.6bb814dc.jpg";